import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractLocalisationInput} from "../abstract-localisation-input";
import {FUIResponsiveService} from "../../../../page/responsive.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterLocalisationInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-localisation-input",
    styleUrls: ["./filter-localisation-input.component.scss"],
    templateUrl: "./filter-localisation-input.component.html",
    standalone: false
})
export class FUIFilterLocalisationInputComponent extends FUIAbstractLocalisationInput {
    constructor(responsiveService: FUIResponsiveService,
                changeDetectorRef: ChangeDetectorRef) {
        super(responsiveService, changeDetectorRef);
    }
}
